import { useTranslation } from 'react-i18next';
import { PageHeader } from 'src/components/common/page-header';
import { UnauthorizedPage } from 'src/components/common/unauthorized';
import { Wttp } from 'src/components/wttp/configuration';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';
import { Can } from 'src/utils/can';

export const WttpConfigurationPage = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'wttp',
  });

  const breadCrumbsProps = {
    items: [{ label: t('wttp-configuration'), link: '' }],
  };

  const title = t('wttp-configuration');

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      <Can I={Actions.Read} a={Subjects.Wttp} appArea={AppArea.Wttp}>
        <Wttp />
      </Can>
      <Can not I={Actions.Read} a={Subjects.Wttp} appArea={AppArea.Wttp}>
        <UnauthorizedPage />
      </Can>
    </>
  );
};
